module.exports = __webpack_public_path__ + "1-16.png?5cfa967a5bf5a1a5c2541171cd81edd9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-16.png
// module id = 93
// module chunks = 0